import React from 'react';
import { Globe2Icon, InstagramIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#09100b] px-5 py-14 text-center" data-id="element-71" data-mp="3gfitaf6445cj">
      <div className="mx-auto max-w-4xl" data-id="element-72" data-mp="32nukakr5twzs">
        <p className="font-display text-3xl font-bold uppercase tracking-wide text-emerald-300" data-id="element-73" data-mp="32ovukn0cqfgg">
          TENNIS PRONTO™
        </p>
        <p className="mt-3 font-bold text-white" data-id="element-74" data-mp="36ppnjusnikg7">
          Il sistema completo per i Maestri di Tennis.
        </p>
        <p className="mt-2 text-sm italic text-slate-300" data-id="element-75" data-mp="3ud7ifz77pyne">
          Perché insegnare Tennis non dovrebbe costarti ogni sera della
          settimana.
        </p>
        <div className="mx-auto mt-8 flex max-w-xl flex-wrap justify-center gap-x-6 gap-y-3 border-y border-emerald-300/20 py-6 text-sm font-semibold text-slate-300" data-id="element-76" data-mp="3ldu4at858lwc">
          <a className="flex items-center gap-2 hover:text-white" href="mailto:support.peready360@gmail.com" data-id="element-77" data-mp="29yxe3g083qne">
            <MailIcon className="h-4 w-4 text-emerald-300" data-id="element-78" data-mp="2ezl0fodibjba" />
            supporto via email
          </a>
          <a className="flex items-center gap-2 hover:text-white" href="https://instagram.com/peready360" data-id="element-79" data-mp="3lbmultja1agf">
            <InstagramIcon className="h-4 w-4 text-emerald-300" data-id="element-80" data-mp="3v89fujfim3iz" />
            Seguici su Instagram
          </a>
          <a className="flex items-center gap-2 hover:text-white" href="https://www.peready360.com" data-id="element-81" data-mp="3q7lo1vjgpinp">
            <Globe2Icon className="h-4 w-4 text-emerald-300" data-id="element-82" data-mp="8178js5jp0n7" />
            Sito ufficiale
          </a>
        </div>
        <p className="mt-8 text-[10px] font-bold uppercase tracking-widest text-slate-500" data-id="element-83" data-mp="3230x5y9rayz">
          TENNIS PRONTO™ — Docenti Elite · © 2026 — Tutti i diritti riservati.
        </p>
      </div>
    </footer>;
}